import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './style/FollowListModal.module.css';
import DOMPurify from 'dompurify'; // 💡 DOMPurify 라이브러리 추가
import { useTranslation } from "react-i18next"; // 👈 추가

export default function FollowListModal({ listType, list, onClose, onFollow, onUnfollow, currentUserId, followingList }) {
  const navigate = useNavigate();
  const { t } = useTranslation(); // 👈 추가
  
  // 💡 listType에 따라 i18n 키로 대체
  const title = listType === 'following' ? t('mypage.modal.follow.title.following') : t('mypage.modal.follow.title.followers');

  // 팔로잉 목록의 userId Set을 만들어 효율적인 검색을 가능하게 함
  const followingUserIds = new Set(followingList.map(user => user.userId));

  const handleUserClick = (userId) => {
    onClose();
    navigate(`/users/${userId}/profile`);
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>{title} ({list.length})</h2>
          <button onClick={onClose} className={styles.closeButton}>×</button>
        </div>
        <div className={styles.modalBody}>
          {list.length === 0 ? (
            <p className={styles.emptyMessage}>
              {/* 💡 listType에 따라 i18n 키로 대체 */}
              {listType === 'following' ? t('mypage.modal.follow.empty.following') : t('mypage.modal.follow.empty.followers')}
            </p>
          ) : (
            <ul className={styles.followUl}>
              {list.map(user => (
                <li key={user.userId} className={styles.followListItem}>
                  <span
                    className={styles.followUserNickname}
                    onClick={() => handleUserClick(user.userId)}
                  >
                    {/* 💡 닉네임 렌더링 시 DOMPurify로 정제 */}
                    {DOMPurify.sanitize(user.nickname)}
                  </span>
                  {user.userId !== currentUserId && (
                    <div className={styles.followActions}>
                      {listType === 'following' || followingUserIds.has(user.userId) ? (
                        <button
                          className={`${styles.actionBtn} ${styles.unfollowBtn}`}
                          onClick={() => onUnfollow(user.userId, user.nickname)}
                        >
                          {/* 💡 i18n 키로 대체 */}
                          {t('mypage.modal.follow.button.unfollow')}
                        </button>
                      ) : (
                        <button
                          className={`${styles.actionBtn} ${styles.followBtn}`}
                          onClick={() => onFollow(user.userId, user.nickname)}
                        >
                          {/* 💡 i18n 키로 대체 */}
                          {t('mypage.modal.follow.button.follow')}
                        </button>
                      )}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}